import { useState } from 'react';
import AdminLayout from './AdminLayout';
import Breadcrumb from '../../components/common/Breadcrumb';
import CategoryManagement from '../../components/admin/CategoryManagement';
import SubcategoryManagement from '../../components/admin/SubcategoryManagement';

const AdminCategoriesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null); // { id, name }

  const breadcrumbs = selectedCategory
    ? [
        { label: 'Dashboard', href: '/admin/dashboard' },
        { label: 'Categories', href: '/admin/categories' },
        { label: selectedCategory.name },
      ]
    : [
        { label: 'Dashboard', href: '/admin/dashboard' },
        { label: 'Categories' },
      ];

  const title = selectedCategory ? `${selectedCategory.name} — Subcategories` : 'Categories';

  return (
    <AdminLayout title={title}>
      <div className="max-w-[1400px]">
        <Breadcrumb items={breadcrumbs} />

        <div className="mb-6">
          <h2 className="text-[20px] font-bold text-slate-800 tracking-tight">{title}</h2>
          <p className="text-[13px] text-slate-500 mt-1">
            {selectedCategory
              ? `Manage subcategories within ${selectedCategory.name}`
              : 'Manage platform categories and their subcategories'}
          </p>
        </div>

        {selectedCategory ? (
          <SubcategoryManagement
            categoryId={selectedCategory.id}
            categoryName={selectedCategory.name}
            onBack={() => setSelectedCategory(null)}
          />
        ) : (
          <CategoryManagement
            onSelectCategory={(id, name) => setSelectedCategory({ id, name })}
          />
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminCategoriesPage;
